const origin = window.location.origin;
const API_URL = process.env.NODE_ENV === 'production'
  ? `${origin}/publisher/`
  : 'https://dev.bidcampaign.com/publisher/';

export default {
  API_URL
};
